import React, { useMemo, useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import Events from "../..";
import { ContainerSize } from "../../../../../models/container.size";
import { ContainerStatus } from "../../../../../models/marine.traffic";
import { Shipment } from "../../../../../models/shipments";
import { useActions } from "../../../../../pages/private/Moving/Waybills/hooks/useAction";
import { DefaultTooltip } from "../../../../Generic/Tooltip";
import { SectionTitle } from "../../../styles";
import { MultipleEventsContainer, Wrapper, InfoIcon, IconContainer } from "./styles";

interface Props {
  shipment?: Shipment;
  containerStatus?: ContainerStatus;
  vesselName?: string;
  isAirTracking?: boolean;
  isCustomerPortal?: boolean;
}

export const MultipleEvents = ({
  containerStatus,
  shipment,
  isAirTracking,
  isCustomerPortal,
}: Props) => {
  const [containerIndexOpened, setContainerIndexOpened] = useState<number>(-1);
  const [containerSizes, setContainerSizes] = useState<ContainerSize[]>([]);

  const { getContainerSizes } = useActions();

  getContainerSizes(setContainerSizes);

  const { t: translate } = useTranslation();

  const containerSizeValue = (value: string) => {
    const sizeValue = containerSizes.find((container) => container.value === value);

    return sizeValue?.label;
  };

  const shipmentHasTracking = useMemo(() => {
    if (!shipment?.shipmentTracking) {
      return false;
    }

    return true;
  }, [shipment]);

  const containerName = useMemo(() => {
    if (isAirTracking) {
      return shipment?.containerId;
    }

    return shipment?.containerNumbers?.toUpperCase();
  }, [shipment]);

  const containers = useMemo(() => {
    if (shipment?.containers?.length) {
      return shipment?.containers?.map((container, index) => {
        return (
          <Events
            shipmentHasTracking={shipmentHasTracking}
            containerName={isAirTracking ? containerName : container?.container?.toUpperCase()}
            containerSize={containerSizeValue(container?.size ?? "")}
            grossWeight={container?.grossWeight}
            containerStatus={containerStatus}
            key={container?.container}
            onToggleEventOpened={() =>
              shipmentHasTracking ? setContainerIndexOpened(index) : undefined
            }
            isEventOpened={containerIndexOpened === index}
            isAirTracking={isAirTracking}
          />
        );
      });
    }

    return (
      <Events
        shipmentHasTracking={shipmentHasTracking}
        containerName={containerName}
        containerStatus={containerStatus}
        isAirTracking={isAirTracking}
      />
    );
  }, [shipment, containerSizes]);

  return (
    <>
      <Grid item xs={12}>
        <Wrapper>
          <SectionTitle>
            {isCustomerPortal ? translate("timeline") : translate("events")}
          </SectionTitle>
          <DefaultTooltip
            placement="right"
            title={translate(
              "theCarrierProvidesDateTimesBelowAndMayNotMatchObservationsAndPredictionsInOtherSections"
            )}
          >
            <IconContainer>
              <InfoIcon size={12} />
            </IconContainer>
          </DefaultTooltip>
        </Wrapper>
      </Grid>
      <MultipleEventsContainer container>{containers}</MultipleEventsContainer>
    </>
  );
};
